import { TRIGGER_BUILD_RECIPES } from '../../apps/appFixer/triggerBuildRecipes.js';

export const triggerBuildFlaws = Object.entries(TRIGGER_BUILD_RECIPES).map(([category, recipe]) => ({
  slug: recipe.flawSlug,
  meaning: recipe.description,
  detectionModes: [],
  severity: 'medium',
  fixCategories: ['pollingTrigger'],
  repairPolicy: 'verified_review',
  verificationBaseMustSucceed: true,
  requiredEvidence: { observationIds: { type: 'stringArray', minItems: 1 }, requestType: { type: 'string', const: 'TRIGGER_REQUEST' }, category: { type: 'string', const: category } },
  evidenceAlternatives: [],
  verificationRecipe: ['Run the unchanged published source action with real records on the job connection.', 'The trigger template is already appended to the candidate. Change only its longPolling.eventDetection. Choose stable ID and creation/update timestamp fields from the provider contract and real output; never guess timestamp semantics.', 'Run the new trigger action ID on the exact final candidate. The server executes the polling source, checks complete pagination, validates every ID/date and tests detection without running customer workflows.', 'If the source needs repairs or timestamp semantics cannot be established, report a blocker instead of changing existing actions or APIs.'],
  legacyCodes: [],
  evidenceRelations: []
}));
